export const COPY_FORGOT_PASSWORD_TITLE = "Forgot your password";
export const COPY_FORGOT_PASSWORD_SUCCESS_TITLE = "Submitted!";
